import { render, staticRenderFns } from "./BillingClient.vue?vue&type=template&id=5702cfe4"
import script from "./BillingClient.vue?vue&type=script&lang=js"
export * from "./BillingClient.vue?vue&type=script&lang=js"
import style0 from "./BillingClient.vue?vue&type=style&index=0&id=5702cfe4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports